var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1155 6.00894C17.0382 5.30651 16.2606 4.18262 16.0181 2.87246C15.9657 2.5894 15.9369 2.29807 15.9369 2H12.4985L12.493 15.78C12.4352 17.3231 11.1651 18.5616 9.60814 18.5616C9.12423 18.5616 8.66858 18.4406 8.2674 18.2295C7.34741 17.7454 6.71781 16.781 6.71781 15.6713C6.71781 14.0775 8.01448 12.7808 9.60814 12.7808C9.90564 12.7808 10.191 12.8299 10.461 12.9145V9.40424C10.1816 9.3662 9.89776 9.34242 9.60814 9.34242C6.1184 9.34242 3.2794 12.1816 3.2794 15.6713C3.2794 17.8124 4.34916 19.7072 5.98119 20.853C7.00917 21.5747 8.25958 22 9.60814 22C13.0979 22 15.9369 19.161 15.9369 15.6713V8.68367C17.2855 9.65161 18.9377 10.222 20.7206 10.222V6.7836C19.7602 6.7836 18.8657 6.49808 18.1155 6.00894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok);
export default __webpack_public_path__ + "static/media/social-tiktok.3f2b262d175c0c4ddff00c803eb80c62.svg";
export { ForwardRef as ReactComponent };